module.exports = __webpack_public_path__ + "img/parking.f097c62d.svg";